import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  link: {
    textDecoration: 'none'
  }
}));

export default function ExternalLink({ href, children, alt}) {
  const classes = useStyles();
  return (
    <a aria-label={alt} alt={alt} className={classes.link} href={href}>
      {children}
    </a>
  );
}
